import { Button, Stack, TextField, Typography } from '@mui/material';
import AreYouSureDelete from '@app/components/AreYouSureDelete';
import { FormProvider } from 'react-hook-form';

import { StyledBox } from './styled';
import { useCreateCategoryLogic } from './useCreateCategoryLogic';

const CreateCategory = () => {
  const {
    methods,
    errors,
    isSuccess,
    isButtonLoading,
    setState,
    onSubmit,
    register,
    handleSubmit,
  } = useCreateCategoryLogic();

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
        sx={{
          gap: '10px',
          '.MuiFormHelperText-root': {
            margin: '0px'
          }
        }}
      >
        <Typography variant="h5">
          Create New Category
        </Typography>
        <StyledBox>
          <TextField
            {...register('titleAm')}
            label="Title Am"
            error={!!errors.titleAm}
            helperText={errors.titleAm ? 'Title is required' : ''}
          />
          <TextField
            {...register('titleEn')}
            label="Title En"
            error={!!errors.titleEn}
            helperText={errors.titleEn ? 'Title is required' : ''}
          />
          <TextField
            {...register('titleRu')}
            label="Title Ru"
            error={!!errors.titleRu}
            helperText={errors.titleRu ? 'Title is required' : ''}
          />
        </StyledBox>
        <p>{isSuccess}</p>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          disabled={isButtonLoading}
        >
          Submit
        </Button>
      </Stack>
    </FormProvider>
  );
};

export default CreateCategory;
